// Shared visual helpers for staff pipeline stages & priorities.
// Colour is always paired with text (never colour-only status) per brand accessibility rule.

export const STAGE_GROUPS = {
  "New enquiry": "open",
  "Qualifying": "open",
  "Quote preparation": "quoting",
  "Quote sent": "quoting",
  "Follow-up": "quoting",
  "Approved": "won",
  "Awaiting payment": "won",
  "Paid": "won",
  "Ready for collection": "won",
  "Dispatched": "won",
  "Completed": "won",
  "Lost": "closed",
  "Cancelled": "closed",
};

export function stageClasses(stage) {
  const g = STAGE_GROUPS[stage];
  switch (g) {
    case "open":
      return "bg-[#D9DEE5] text-[#061A33] border-[#061A33]/15";
    case "quoting":
      return "bg-ei-gold/15 text-ei-golddark border-ei-gold/40";
    case "won":
      return "bg-[#061A33] text-ei-white border-[#061A33]";
    case "closed":
      return "bg-red-50 text-red-800 border-red-200";
    default:
      return "bg-[#D9DEE5] text-[#061A33] border-[#061A33]/15";
  }
}

export function priorityClasses(priority) {
  switch (priority) {
    case "Urgent":
      return "bg-red-100 text-red-800 border-red-300";
    case "High":
      return "bg-ei-gold/20 text-ei-golddark border-ei-gold/50";
    case "Normal":
      return "bg-[#D9DEE5] text-[#263241] border-[#263241]/15";
    case "Low":
      return "bg-white text-ei-graphite/70 border-ei-mist";
    default:
      return "bg-[#D9DEE5] text-[#263241] border-[#263241]/15";
  }
}

export function fmtDate(iso, withTime = false) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    const opts = withTime
      ? { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: "Australia/Melbourne" }
      : { day: "numeric", month: "short", year: "numeric", timeZone: "Australia/Melbourne" };
    return new Intl.DateTimeFormat("en-AU", opts).format(d);
  } catch {
    return iso;
  }
}

export function isOverdue(iso, stage) {
  if (!iso) return false;
  if (["Completed", "Lost", "Cancelled"].includes(stage)) return false;
  try {
    return new Date(iso) < new Date();
  } catch {
    return false;
  }
}
